import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeck = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0H24V24H0z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M22 9L12 2 2 9 11 9 11 22 13 22 13 9z" }),
		/* @__PURE__ */ _jsx("path", { d: "M4.14 12L2.18 12.37 3 16.74 3 22 5 22 5.02 18 7 18 7 22 9 22 9 16 4.9 16z" }),
		/* @__PURE__ */ _jsx("path", { d: "M19.1 16L15 16 15 22 17 22 17 18 18.98 18 19 22 21 22 21 16.74 21.82 12.37 19.86 12z" })
	]
});
export default SvgDeck;
